import { useAsync } from 'react-use';
import { SilentAuthError } from '@spotify-internal/oauth-silent-authentication';

import * as Sentry from 'lib/client/sentry/sentry';
import { ErrorMessage } from 'containers/ContentReporting/ContentPolicyReporting/utils/types';
import auth from 'lib/shared/auth/auth';

export interface UserData {
  username?: string;
  email?: string;
}

export const useUserData = () => {
  const { value, loading, error } = useAsync(async (): Promise<UserData> => {
    try {
      const userInfo = await auth.getUserInfo();

      return {
        username: userInfo.profile?.username,
        email: userInfo.email,
      };
    } catch (e: unknown) {
      const silentAuthError = e as SilentAuthError;
      if (silentAuthError.error !== 'login_required') {
        Sentry.captureException(`Error under useUserData: ${JSON.stringify(e)}`);
      }
    }
    return Promise.reject(ErrorMessage.CONTENT_REQUEST_ERROR);
  }, []);

  return {
    isLoading: loading,
    error,
    userData: value,
  };
};

export default useUserData;
